<template>
  <div>
    <div class="p-3 my-2 rounded shadow d-flex justify-space-between align-center" v-for="(area, index) in areas"
      :key="`area_${index}`">
      <div id="name-block">
        <span class="d-block">{{ $t('area.rented_stall') }}</span>
        <h3 class="primary--text d-inline">{{ area.name }}</h3>
        <span class="red--text" v-if="area.isRemoved">({{ $t('area.stall_deleted') }})</span>
        <ul v-if="area.products">
          <li v-for="(product, index) of area.products" :key="index">{{ product.name }}</li>
        </ul>
      </div>
      <div id="manage-block" v-show="isShow">
        <v-btn color="warning" @click="onChangeAreaProduct(area)" small elevation="0"
          :disabled="!getContract.isActive">{{ $t('product.edit_product') }}</v-btn>
        <!-- <v-btn small elevation="0" class="ml-2" color="error" @click="onSelectDel(area)"
          :disabled="!getContract.isActive || (adminMarket && adminMarket.objectId ? false : true)">{{ $t('action_type.delete') }}</v-btn> -->
      </div>
    </div>
    <div class="shadow rounded bg-white px-3 py-2" v-if="!areas || !areas.length"> {{ $t('contract.no_stall_in_this_contract') }}</div>
    <v-dialog v-model="showDialog" persistent max-width="400">
      <v-card>
        <v-card-title>{{ $t('validate.want_to_delete') }}</v-card-title>
        <v-card-text class="py-5">
          {{ $t('area.rented_stall') }}
          <b>{{ delObj.name }}</b> {{ $t('contract.question_in_contract') }}
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="grey" dark elevation="0" @click="onCancel()">
            <v-icon left>mdi-window-close</v-icon>{{ $t('cancel') }}
          </v-btn>
          <v-btn color="error" elevation="0" @click="delSave">
            <v-icon left>mdi-delete</v-icon>{{ $t('action_type.delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "AreasList",
  data() {
    return {
      objectId: "",
      dialog: false,
      project: null,
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      delObj: "",
      showDialog: false
    };
  },
  props: {
    areas: Array,
    value: Boolean,
    isShow: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({
      getContract: "contract/getContract",
      getAdminByMarketId: "admin/getByMarketId",
      getAdminByProjectId: "admin/getByProjectId",
      getEmployeeByProjectId: "employee/getByProjectId",
    }),
    adminMarket() {
      return this.getAdminByMarketId(this.marketId);
    },
    admins() {
      return this.getAdminByProjectId(this.projectId);
    },
    employees() {
      return this.getEmployeeByProjectId(this.projectId);
    }
  },
  watch: {
    admins() {
      if (this.admins && this.admins.length) this.initData();
    },
    employees() {
      if (this.employees && this.employees.length) this.initData();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    onChangeAreaProduct(item) {
      this.$emit("onChangeAreaProduct", item);
    },
    onCancel() {
      this.showDialog = false;
    },
    onSelectDel(item) {
      this.showDialog = true;
      this.delObj = item;
    },
    delSave() {
      this.showDialog = false;
      this.$emit("onDelSave", this.delObj);
    },
    initData() {
      if (this.admins && this.admins.length) {
        this.project = this.admins[0].project;
      } else if (this.employees && this.employees.length) {
        this.project = this.employees[0].project;
      } else {
        this.$router.push(`/notFound`);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.show-area-2 {
  transition: all 0.2s;
  cursor: pointer;
  border-width: 1px !important;
  box-shadow: 10px 5px 0px 0px rgb(0 0 0 / 3%) !important;
  background: #fdfdfd !important;
}

.show-area-2:hover {
  transform: translateY(-5px);
  // box-shadow: 0px 51px 20px -48px rgba(0, 0, 0, 0.29) !important;
  box-shadow: 10px 10px 0px 0px rgb(0 0 0 / 3%) !important;
  border-width: 1px !important;
  border-color: #eee !important;
}

.show-area {
  transition: all 0.2s;
  cursor: pointer;
  border-width: 1px !important;
  // box-shadow: 0px 5px 12px 7px rgb(0 0 0 / 3%) !important;
  box-shadow: 0px 10px 0px 0px rgb(0 0 0 / 3%) !important;
}

.show-area:hover {
  transform: translateY(-10px);
  // box-shadow: 0px 51px 20px -48px rgba(0, 0, 0, 0.29) !important;
  border-width: 1px !important;
  border-color: #eee !important;
  box-shadow: 0px 20px 0px 0px rgb(0 0 0 / 3%) !important;
}
</style>
